module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=IE - Ireland.278a8bc7.svg";